<template>
  <div class="content">
    <div class="set_flexwrap">
      <div class="flex_wrap">
        <p class="noticeP mb20">名称和图标可修改，最多可同时存在5个导航，仅在小程序端显示，AI雷达推送及数据统计暂按原有名称显示 </p>
        <el-button class="mt20" type="primary" size="small" @click="onOpenDialog">设置默认页</el-button>
        <div class="mt20 clearfix">
          <div class="whd-nav-item" v-for="(item, index) in iconBottonNav" :key="item.subtype" :label="tabs[index]">
            <p class="font14">{{tabs[index]}}</p>
            <div class="iconNav" @click="iconCheckFn(index+1)">
              <img :src="item.light_pic?item.light_pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'" alt="">
            </div> 
            <el-input type="text" class="mb10" maxlength="4" show-word-limit :placeholder="tabs[index]" v-model="item.content"></el-input> 
            <div v-if="index < iconBottonNav.length - 1"><span class="font14 whd-gray666">是否开启该栏目</span>
            <el-switch
                    class="ml10 whd-switch"
                    v-model="item.on_off"
                    active-color="#2AA3F8"
                    inactive-color="#ddd"
                    :active-value="1"
                    :inactive-value="0"
                    :disabled="item.is_default==1?true:false"
                    @change="onSwitch($event, index)"
            ></el-switch>
            </div> 
            <el-button v-if="index < iconBottonNav.length - 1" type="text" :disabled="index == 0 ? true : false" @click="onSetSort(index, 'up')">左移</el-button>
            <el-button v-if="index < iconBottonNav.length - 1" type="text" :disabled="index == iconBottonNav.length - 2 ? true : false" @click="onSetSort(index, 'down')">右移</el-button>         
          </div>
        </div>
        <el-button class="mt20" type="primary" size="small" @click="saveIconFn">保存</el-button>
      </div>
      <div class="preview_wrap">
        <div class="cardtitle_preview">
          <div class="box">
            <img src="/static/img/card.jpg" alt>
          </div>
          <div class="preview_modul"></div>
          <div class="preview_bottom">
            <template v-for="item in iconBottonNav">
              <div v-if="item.on_off==1" :key="item.subtype" class="preview_bottom_list">
                <div class="preview_bottom_list_img">
                  <img :src="item.light_pic?item.light_pic:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'" alt="">
                </div>
                <p class="preview_bottom_list_title">{{item.content}}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <iconListDialog :visible.sync="icondialog" v-if="icondialog" @getIconSrc="getIconSrc"></iconListDialog>
    <el-dialog
      custom-class="whd-nav-dialog"
      title="设置默认页"
      width="320px"
      :visible.sync="dialogVisible"
      >
      <span>默认展开页</span>
      <el-select class="ml10" v-model="radio" placeholder="请选择默认页">
        <el-option
          v-for="(item, index) in iconBottonNav"
          :key="index"
          :label="item.content"
          :value="index"
          :disabled="(item.on_off==0 || item.subtype==5 || item.subtype==6)?true:false">
        </el-option>
      </el-select>      
      <div class="mt20 whd-tright">
        <el-button type="primary" size="small" @click="onComfir">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import iconListDialog from "@/components/dialog/iconListDialog.vue";
  import api from "@/api.js"

  export default {
    name: "SettingsBottomNav",
    data() {
      return {
        icondialog: false,
        tabs: ['导航一', '导航二', '导航三', '导航四', '导航五', '导航六', '导航七', '导航八', '导航九', '导航十'],
        iconBottonNav: [
          {content: '名片', pic: '', light_pic:'', subtype:1},
          {content: '产品', pic: '', light_pic:'', subtype:2},
          {content: '动态', pic: '', light_pic:'', subtype:3},
          {content: '官网', pic: '', light_pic:'', subtype:4},
          {content: '购物车', pic: '', light_pic:'', subtype:6},
          {content: '相册', pic: '', light_pic:'', subtype:7},
          {content: '知识库', pic: '', light_pic:'', subtype:8},
          {content: '积分商城', pic: '', light_pic:'', subtype:9},
          {content: '推广员', pic: '', light_pic:'', subtype:10},
          {content: '我的', pic: '', light_pic:'', subtype:5}
        ],
        checkIndex: 0,
        is_dynamic: 0,
        dynamic_intro: "",
        radio: 1,
        company_id: 0,
        idx: 0,
        dialogVisible: false,
        selected: 0
      };
    },
    components: {
      iconListDialog
    },
    created() {
      this.InitFn()
    },
    methods: {
      onSwitch(option, index) {
        if (option === 1) {
          if (this.selected >= 4) {
            this.$set(this.iconBottonNav[index], 'on_off', 0);
            this.$message.error('最多只能设置5个导航栏');
            return
          } else {
            this.selected++;
          }
        } else {
          this.selected--;
        }
      },
      onSetSort(index, option) {
        // 上移
        if (option == 'up') {
          const data = this.iconBottonNav[index - 1];
          this.iconBottonNav.splice(index - 1, 1);
          this.iconBottonNav.splice(index, 0, data);
        } 
        // 下移
        if (option == 'down') {
          const data = this.iconBottonNav[index + 1];
          this.iconBottonNav.splice(index + 1, 1);
          this.iconBottonNav.splice(index, 0, data);        
        } 
        for (let i = 0; i < this.iconBottonNav.length - 1; i++) {
          if (this.iconBottonNav[i].is_default == 1) {
            this.radio = i + 1;
          }
        }
      },
      radioChange(e, index) {
        for (let i = 0; i < this.iconBottonNav.length - 1; i++) {
          this.iconBottonNav[i].is_default = 0
          if (i == index) {
             this.iconBottonNav[i].is_default = 1
          }
        }
      },
      InitFn() {
        this.axios
            .post(api.bottom_navigation_index, {})
            .then(response => {
              if (response.data.code == 0) { 
                this.company_id = response.data.company_id 
                this.iconBottonNav = response.data.info.bottom_navigation       
                for(let i = 0; i < response.data.info.bottom_navigation.length - 1; i++){
                  this.iconBottonNav[i].content = response.data.info.bottom_navigation[i].content
                  this.iconBottonNav[i].pic = response.data.info.bottom_navigation[i].pic
                  this.iconBottonNav[i].light_pic = response.data.info.bottom_navigation[i].light_pic
                  this.iconBottonNav[i].on_off = parseInt(response.data.info.bottom_navigation[i].on_off) 
                  this.iconBottonNav[i].is_default = parseInt(response.data.info.bottom_navigation[i].is_default)
                  if (response.data.info.bottom_navigation[i].is_default == 1) {
                    const idx = i
                    this.radio = i 
                    this.idx = idx
                  }
                  if (response.data.info.bottom_navigation[i].on_off == 1) {
                    this.selected++;
                  }
                }
              } 
            })
            .catch(response => {
            });
      },
      iconCheckFn(option) {
        this.checkIndex = option
        this.icondialog = true
      },
      getIconSrc(option) {
        if (option.icon) {
          for (let i = 0; i<option.icon.length; i++) {
            for (let j = 0; j < this.iconBottonNav.length; j++) {
              if (option.icon[i].subtype == this.iconBottonNav[j].subtype) {
                this.iconBottonNav[j].pic = option.icon[i].pic  
                this.iconBottonNav[j].light_pic = option.icon[i].light_pic  
              }
            }
          }
        } else {
          this.iconBottonNav[this.checkIndex].pic = option.pic
          this.iconBottonNav[this.checkIndex].light_pic = option.light_pic
        }
      },
      onOpenDialog() {
        this.iconBottonNav.map((item, index) => {
          if (item.is_default == 1) {
            this.radio = index
            this.dialogVisible = true
          }
        })
      },
      onComfir() {
        this.dialogVisible = false
        this.iconBottonNav.map((item, index) => {
          item.is_default = 0
          if (this.radio == index) {
            item.is_default = 1
          }
        })
      },
      saveIconFn() {
        let status_name = 0;
        let status_pic = 0;
        for (let i in this.iconBottonNav) {
          if (!this.iconBottonNav[i].content) {
            status_name = 1;
          }
          if (!this.iconBottonNav[i].pic) {
            status_pic = 1;
          }
        }
        if (status_name === 1) {
          this.$message.error('请填写相应导航名称');
          return
        }
        if (status_pic === 1) {
          this.$message.error('请选择图标');
          return
        }
        this.axios
            .post(api.bottom_navigation_edit, {bottom_navigation:this.iconBottonNav})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '设置成功！',
                });
              } 
            })
            .catch(response => {
            });
      }
    }
  };
</script>